import { Check, ContentCopy } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface CopyButtonProps extends ButtonProps {
  tooltip: string;
  value?: string;
}

const CopyButton = (props: CopyButtonProps) => {
  const { t } = useTranslation();
  const { tooltip, value, ...buttonProps } = props;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Button
      {...buttonProps}
      fullWidth
      title={tooltip}
      className="copy-button checkmark"
      onClick={handleCopy}
      endIcon={
        <div title={t("clickToCopy")}>
          {copied ? <Check className="checkmark" /> : <ContentCopy />}
        </div>
      }
    >
      {buttonProps.children}
    </Button>
  );
};

export default CopyButton;
